export const required = val => {
  if (!val) return 'This field is required';

  return null;
};

// Todo: implement
export const email = val => val;

export const validatePhone = phone => {
  if (
    !/^((\+447|07|00447|08)(\s?\d{1}){9})$|((01|02|03)(\s?\d{1}){5,20})$/.test(
      phone,
    )
  ) {
    // eslint-disable-next-line quotes
    return "Please ensure you enter a valid UK landline or mobile number beginning with '0' or '+44'";
  }
};

export const validatePassword = val => {
  if (!/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/.test(val)) {
    return 'Password must contain at least one number and one character.';
  }
};
